import { easingFunctions } from '.';

/**
 * Animate an Element.scrollLeft assignment.
 * Borrowed from: https://codepen.io/matths/pen/yjbis
 * @param {HTMLElement} wrapper DOM element that should scroll
 * @param {string} easingType the name of an easing function from './easingFunctions'
 * @param {number} scrollAmount total number of pixels to scroll
 * @param {number} scrollDuration time in milliseconds for the scrolling to take
 */
export const animateScrollLeft = (
    wrapper: HTMLElement,
    easingType: keyof EasingFunctions,
    scrollAmount: number,
    scrollDuration: number,
): void => {
    const easingFunction = easingFunctions[easingType];

    const tween = (
        start: number,
        end: number,
        duration: number,
        easing: EasingFunction,
    ): void => {
        const delta = end - start;
        let startTime = -1;

        if (window?.performance?.now !== undefined) {
            startTime = performance.now();
        } else if (Date.now) {
            startTime = Date.now();
        } else {
            startTime = new Date().getTime();
        }

        const tweenLoop = (time?: number): void => {
            const t = !time ? 0 : time - startTime;
            const factor = easing(null, t, 0, 1, duration);

            if (wrapper) {
                // The browser API for scrollLeft requires us to reassign the parameter
                // eslint-disable-next-line no-param-reassign
                wrapper.scrollLeft = start + delta * factor;

                if (t < duration && wrapper.scrollLeft !== end) {
                    requestAnimationFrame(tweenLoop);
                }
            }
        };

        tweenLoop();
    };

    tween(0, scrollAmount, scrollDuration, easingFunction);
};
